// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iTV9","content":"styles_content__3LyoG"};